import { navigateToLogin } from '~/utils/externalRouting'

export const useAuthStore = defineStore('auth', () => {
  const config = useRuntimeConfig()
  const url = useRequestURL()
  const toast = useToast()

  const { execute, error } = useApiAuthPostLogout({ server: false })

  const logout = async () => {
    await execute()
    if (!error.value)
      await navigateToLogin(config.public.loginRoute, url)
    else if (error.value.data)
      toast.add({ color: 'error', description: error.value.data.message })
  }

  return {
    logout,
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot))
